import CarteiraConstans from "../../infra/data/carteiraConstants";
import { Get } from "domain/infra/data/api";
import { ExtratoRequest } from './../../types/extrato/extratoRequest';
import { ExtratoResponse } from "../../types/extrato/extratoResponse";

export class ExtratoService {
  constructor() {
    //super()
  }

  async GetExtrato(data: ExtratoRequest, carteiraId: number): Promise<ExtratoResponse[] | Error> {
    let url = `${CarteiraConstans.apiCarteira.carteira.getExtrato(carteiraId)}`;

    if (data.From.length !== 0) {
      url += `?From=${data.From}&To=${data.To}`;
    }

    const response: ExtratoResponse[] | Error = await Get(url);
    return response;
  }
}
